const headers = [
  {
    id: 1,
    title: "名称",
    class: "name",
    sort: "des",
    showSort: true,
    field: {
      "persona-file": "name",
      file: "name",
      star: "name",
      trash: "name",
      sharefile: "share_title",
      shareme: "share_title",
      "group-file": "name",
      "group-share": "share_title",
      "group-send": "share_title",
      "groupdisk-file": "name",
      "groupdisk-share": "share_title",
      "groupdisk-send": "link_title",
      "persona-sharefile": "share_title",
    },
    display: [
      "file",
      "star",
      "trash",
      "sharefile",
      "shareme",
      "group-file",
      "group-share",
      "group-send",
      "groupdisk-file",
      "groupdisk-share",
      "groupdisk-send",
      "persona-file",
      "persona-sharefile"
    ]
  },
  {
    id: 9,
    title: "权限",
    class: "size",
    sort: "des",
    showSort: false,
    field: "bytes",
    display: [
      "groupdisk-file"
    ]
  },
  {
    id: 2,
    title: "大小",
    class: "size",
    sort: "des",
    showSort: false,
    field: "bytes",
    display: [
      "file",
      "star",
      "trash",
      "persona-file",
      "group-file",
      "groupdisk-file"
    ]
  },
  {
    id: 3,
    title: "修改日期",
    class: "time",
    sort: "asc",
    showSort: false,
    field: "last_update_date",
    display: [
      "file",
      "star",
      "trash",
      "persona-file",
      "group-file",
      "groupdisk-file"
    ]
  },
  {
    id: 4,
    title: "创建人",
    class: "author",
    sort: "des",
    showSort: false,
    field: "creater_user_real_name",
    display: [
      "file",
      "star",
      "trash",
      "persona-file",
      "group-file",
      "groupdisk-file"
    ]
  },
  {
    id: 5,
    title: "分享给",
    class: "share",
    sort: "des",
    showSort: false,
    field: "share_sharers",
    display: ["sharefile", "persona-sharefile"]
  },
  {
    id: 6,
    title: "分享自",
    class: "share",
    sort: "des",
    showSort: false,
    field: "share_creater_name",
    display: ["shareme", "group-share", "groupdisk-share"]
  },
  {
    id: 61,
    title: "发布自",
    class: "share",
    sort: "des",
    showSort: false,
    field: "link_creater_name",
    display: ["group-send", "groupdisk-send"]
  },
  {
    id: 7,
    title: "分享时间",
    class: "time",
    sort: "asc",
    showSort: false,
    field: "share_created_date",
    display: [
      "sharefile",
      "shareme",
      "group-share",
      "groupdisk-share",
      "persona-sharefile"
    ]
  },
  {
    id: 71,
    title: "发布时间",
    class: "time",
    sort: "asc",
    showSort: false,
    field: "link_created_date",
    display: [
      "group-send",
      "groupdisk-send"
    ]
  },
  {
    id: 8,
    title: "浏览次数",
    class: "views",
    sort: "des",
    showSort: false,
    field: {
      sharefile: "share_view_count",
      shareme: "share_view_count",
      "groupdisk-share": "share_view_count",
      "groupdisk-send": "link_view_count",
      "persona-sharefile": "share_view_count",
    },
    display: [
      "sharefile",
      "shareme",
      "groupdisk-share",
      "groupdisk-send",
      "persona-sharefile"
    ]
  }
];
export default headers;